import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageAr() {
    return (
<div className="privacy-policy-container">
<h1>سياسة الخصوصية لتطبيق تسبيح ذكر لايت</h1>
      <p>آخر تحديث: 31 يناير 2024</p>

      <h2>مقدمة</h2>
      <p>مرحبًا بكم في تطبيق تسبيح ذكر لايت. تهدف هذه السياسة إلى إعلامكم بكيفية التعامل مع بياناتكم عند استخدام التطبيق. الجمع الوحيد للبيانات في هذا التطبيق يتم عن طريق AdMob، وهي خدمة إعلانات من Google، ونحن لا نجمع بيانات شخصية بشكل نشط.</p>

      <h2>1. جمع واستخدام بياناتك الشخصية</h2>
      <h3>أ. أنواع البيانات المجمعة</h3>
      <h4>ط. استخدام البيانات من خلال AdMob</h4>
      <p>يستخدم تطبيقنا AdMob لعرض الإعلانات. يمكن لـ AdMob جمع بيانات مثل عنوان IP الخاص بك، معرف جهازك، ومعلومات حول استخدامك للتطبيق. يتم استخدام هذه التفاصيل لتوفير وتحسين تجربة الإعلان.</p>

      <h3>ب. استخدام البيانات</h3>
      <p>البيانات التي يتم جمعها من قبل AdMob تستخدم لـ:</p>
      <ul>
        <li>توفير وتخصيص الإعلانات داخل التطبيق.</li>
        <li>تحليل فعالية الإعلانات المعروضة.</li>
      </ul>

      <h3>ج. التحكم من قبل المستخدم</h3>
      <p>يمكنك التحكم في استخدام بياناتك للإعلانات المخصصة من خلال إعدادات جهازك.</p>

      <h2>2. نقل البيانات</h2>
      <p>قد يتم نقل معلوماتك وصيانتها على أجهزة الكمبيوتر التي تقع خارج دولتك أو مقاطعتك أو بلدك حيث قد تختلف قوانين حماية البيانات.</p>

      <h2>3. الكشف عن بياناتك الشخصية</h2>
      <p>قد يتم مشاركة البيانات التي يتم جمعها بواسطة AdMob وفقًا لسياسة خصوصية Google والمتطلبات القانونية.</p>

      <h2>4. أمان بياناتك الشخصية</h2>
      <p>أمان بياناتك مهم لنا. ومع ذلك، لا توجد طريقة للنقل عبر الإنترنت أو طريقة للتخزين الإلكتروني آمنة بنسبة 100%.</p>

      <h2>5. الروابط إلى مواقع أخرى</h2>
      <p>قد يحتوي خدمتنا على روابط إلى مواقع أخرى. إذا نقرت على رابط لطرف ثالث، ستتم إعادة توجيهك إلى موقع ذلك الطرف الثالث.</p>

      <h2>6. تغييرات على هذه السياسة</h2>
      <p>قد نحدث سياسة الخصوصية هذه من وقت لآخر. سنقوم بإعلامك بأي تغييرات من خلال نشر السياسة الجديدة على هذه الصفحة.</p>

      <h2>7. اتصل بنا</h2>
      <p>إذا كان لديك أي أسئلة حول هذه السياسة، يرجى الاتصال بنا.</p>

      <h2>روابط مفيدة</h2>
      <p><a href="https://policies.google.com/privacy">سياسة خصوصية Google</a></p>
    </div>
    




                //  Ancienne version payante de l'app : 

//     <h1>سياسة الخصوصية</h1>
//     <p>آخر تحديث في 18 يناير 2024</p>
    
//     <p>توضح هذه الإشعارة بشأن الخصوصية لشركة يوزلت ("نحن"، "نحن" أو "شركتنا") كيفية جمعنا وتخزيننا واستخدامنا و/أو مشاركتنا ("معالجة") معلوماتك عند استخدامك لخدماتنا ("الخدمات")، مثل عندما:</p>
//     <ul>
//         <li>تنزيل واستخدام تطبيقنا المحمول (تسبيح ذكر)، أو أي تطبيق آخر لنا يرتبط بهذا الإشعار بشأن الخصوصية</li>
//         <li>المشاركة معنا بطرق أخرى ذات صلة، بما في ذلك أي مبيعات أو تسويق أو فعاليات</li>
//     </ul>
//     <p>هل لديك أسئلة أو مخاوف؟ قراءة هذه الإشعارة بشأن الخصوصية ستساعدك في فهم حقوقك وخياراتك فيما يتعلق بالخصوصية. إذا لم توافق على سياساتنا وممارساتنا، يرجى عدم استخدام خدماتنا.</p>

//     <h2>ملخص النقاط الرئيسية</h2>
//     <p>يوفر هذا الملخص النقاط الرئيسية من إشعارنا بشأن الخصوصية، ولكن يمكنك معرفة المزيد من التفاصيل حول أي من هذه الموضوعات عن طريق النقر على الرابط التالي لكل نقطة رئيسية أو باستخدام جدول المحتويات الخاص بنا أدناه للعثور على القسم الذي تبحث عنه.</p>



//     <h2>جدول المحتويات</h2>
// <ol>
//     <li>ماهي المعلومات التي نقوم بجمعها؟</li>
//     <li>كيف نقوم بمعالجة معلوماتك؟</li>
//     <li>على أي الأسس القانونية نعتمد لمعالجة معلوماتك الشخصية؟</li>
//     <li>متى ومع من نشارك معلوماتك الشخصية؟</li>
//     <li>مدى فترة الاحتفاظ بمعلوماتك؟</li>
//     <li>كيف نحفظ معلوماتك بأمان؟</li>
//     <li>ما هي حقوق خصوصيتك؟</li>
//     <li>ضوابط ميزات "عدم التتبع" (Do-Not-Track)</li>
//     <li>هل لدى سكان الولايات المتحدة الأمريكية حقوق خصوصية محددة؟</li>
//     <li>هل نقوم بتحديث هذه الإشعارة؟</li>
//     <li>كيف يمكنك الاتصال بنا بخصوص هذه الإشعارة؟</li>
//     <li>كيف يمكنك مراجعة وتحديث أو حذف البيانات التي نجمعها منك؟</li>
// </ol>

// <h3>1. ما هي المعلومات التي نقوم بجمعها؟</h3>
// <h4>المعلومات الشخصية التي تكشفها لنا</h4>
// <p>باختصار: نقوم بجمع المعلومات الشخصية التي تقدمها لنا.</p>
// <p>نقوم بجمع المعلومات الشخصية التي تقدمها طوعاً عندما تعبّر عن اهتمامك بالحصول على معلومات عنا أو منتجاتنا وخدماتنا، عندما تشارك في الأنشطة على الخدمات، أو عندما تتصل بنا بأي شكل آخر.</p>
// <p>المعلومات الحساسة: لا نقوم بمعالجة المعلومات الحساسة.</p>
// <p>يجب أن تكون جميع المعلومات الشخصية التي تقدمها لنا صحيحة وكاملة ودقيقة، ويجب عليك إعلامنا بأي تغييرات في مثل هذه المعلومات الشخصية.</p>

// <h3>2. كيف نقوم بمعالجة معلوماتك؟</h3>
// <p>باختصار: نقوم بمعالجة معلوماتك لتقديم وتحسين وإدارة خدماتنا، والتواصل معك، وللأمان ومنع الاحتيال، وللامتثال للقانون. قد نقوم أيضًا بمعالجة معلوماتك لأغراض أخرى بموافقتك.</p>

// <p>نقوم بمعالجة معلوماتك الشخصية لأسباب متنوعة، اعتمادًا على كيفية تفاعلك مع خدماتنا، بما في ذلك:</p>
// <ul>
//     <li>لحفظ أو حماية مصلحة شخص ما بشكل حيوي. قد نقوم بمعالجة معلوماتك عند الضرورة لحفظ أو حماية مصلحة حيوية لشخص ما، مثل الوقاية من الأذى.</li>
// </ul>

// <h3>3. على أي الأسس القانونية نعتمد لمعالجة معلوماتك؟</h3>
// <p>باختصار: نقوم بمعالجة معلوماتك الشخصية فقط عندما نعتقد أنها ضرورية ولدينا سبب قانوني صحيح (أي أساس قانوني) للقيام بذلك وفقًا للقوانين المعمول بها، مثل موافقتك، أو للامتثال للقوانين، أو لتقديم لك خدمات للدخول في التزاماتنا التعاقدية أو تنفيذها، أو لحماية حقوقك، أو لتحقيق مصالح أعمالنا المشروعة.</p>
// <p>إذا كنت موجودًا في الاتحاد الأوروبي أو المملكة المتحدة، ينطبق هذا القسم عليك.</p>
// <p>تتطلب لائحة حماية البيانات العامة (GDPR) ولائحة حماية البيانات في المملكة المتحدة (UK GDPR) منا شرح الأسس القانونية الصحيحة التي نعتمد عليها لمعالجة معلوماتك الشخصية. وبناءً على ذلك، قد نعتمد على الأسس القانونية التالية لمعالجة معلوماتك الشخصية:</p>
// <ul>
//     <li>الموافقة. قد نقوم بمعالجة معلوماتك إذا قدمت لنا إذنًا (أي موافقة) لاستخدام معلوماتك الشخصية لأغراض محددة. يمكنك سحب موافقتك في أي وقت.</li>
//     <li>الالتزامات القانونية. قد نقوم بمعالجة معلوماتك حيث نعتقد أنها ضرورية للامتثال لالتزاماتنا القانونية، مثل التعاون مع جهاز إنفاذ القانون أو الجهة التنظيمية، أو ممارسة أو دفاع حقوقنا القانونية، أو الكشف عن معلوماتك كدليل في التحكيم الذي نشارك فيه.</li>
//     <li>المصلحة الحيوية. قد نقوم بمعالجة معلوماتك حيث نعتقد أنها ضرورية لحماية مصلحتك الحيوية أو مصلحة طرف ثالث، مثل المواقف التي تنطوي على تهديدات محتملة لسلامة أي شخص.</li>
// </ul>
// <p>إذا كنت موجودًا في كندا، ينطبق هذا القسم عليك.</p>

// <p>قد نقوم بمعالجة معلوماتك إذا قدمت لنا إذنًا محددًا (أي موافقة صريحة) لاستخدام معلوماتك الشخصية لأغراض محددة، أو في حالات يمكن الاستدلال فيها على موافقتك (أي موافقة ضمنية). يمكنك سحب موافقتك في أي وقت.</p>
// <p>في بعض الحالات الاستثنائية، قد نكون مسموحًا قانونيًا بمعالجة معلوماتك دون الحصول على موافقتك وفقًا للقانون المعمول به، بما في ذلك، على سبيل المثال:</p>
// <ul>
//     <li>إذا كان جمع المعلومات يخدم بوضوح مصلحة فردية ولا يمكن الحصول على موافقة في الوقت المناسب</li>
//     <li>لأغراض التحقيق والكشف والوقاية من الاحتيال</li>
//     <li>للمعاملات التجارية شريطة توفر الشروط المعينة</li>
//     <li>إذا كانت مدرجة في بيان شاهد وكان جمعها ضروريًا لتقييم أو معالجة أو تسوية مطالبة تأمين</li>
//     <li>لتحديد الأشخاص المصابين أو المرضى أو الذين توفوا والتواصل مع الأقارب</li>
//     <li>إذا كان لدينا أسباب معقولة للاعتقاد بأن فردًا قد تعرض للإساءة المالية أو قد يتعرض لها</li>
//     <li>إذا كان من المعقول أن يكون جمع المعلومات واستخدامها مع موافقة قد يعرض توافر المعلومات أو دقتها للتهديد وكان جمعها مناسبًا لأغراض تتعلق بالتحقيق في انتهاك اتفاق أو انتهاك للقوانين الكندية أو قانون إقليمي</li>
//     <li>إذا كانت الكشف مطلوبًا للامتثال لإرسال استدعاء أو أمر تفتيش أو أمر قضائي أو لقواعد المحكمة المتعلقة بإنتاج السجلات</li>
//     <li>إذا تم إنتاجها بواسطة فرد في إطار عمله أو عمله التجاري أو مهنته وكان الجمع متسقًا مع الأغراض التي تم إنتاج المعلومات من أجلها</li>
//     <li>إذا كان الجمع يخدم فقط أغراض صحفية أو فنية أو أدبية</li>
//     <li>إذا كانت المعلومات متاحة للجمهور وتم تحديدها بموجب اللوائح</li>
// </ul>


// <h3>4. متى ومع من نشارك معلوماتك الشخصية؟</h3>
// <p>باختصار: قد نشارك المعلومات في حالات محددة موجودة في هذا القسم و/أو مع أطراف ثالثة معينة.</p>
// <p>قد نحتاج إلى مشاركة معلوماتك الشخصية في الحالات التالية:</p>
// <ul>
//     <li>التحويلات التجارية. قد نقوم بمشاركة أو نقل معلوماتك فيما يتعلق بأو أثناء المفاوضات حول أي عملية دمج أو بيع لأصول الشركة أو تمويل أو استحواذ على كامل أو جزء من أعمالنا إلى شركة أخرى.</li>
// </ul>


//             {/* Section 5 */}
//             <h3>5. مدى الوقت الذي نحتفظ فيه بمعلوماتك؟</h3>
// <p>باختصار: نحتفظ بمعلوماتك لما يلزم لتحقيق الأغراض المبينة في هذا إشعار الخصوصية ما لم يقتضي الأمر خلاف ذلك بموجب القانون.</p>
// <p>سنحتفظ بمعلوماتك الشخصية فقط لما يلزم لأغراض محددة في هذا إشعار الخصوصية، ما لم يتطلب الأمر فترة تخزين أطول أو يسمح به القانون (مثل الضرائب أو المتطلبات المحاسبية أو القانونية الأخرى).</p>
// <p>عندما ليس لدينا حاجة تجارية مشروعة مستمرة لمعالجة معلوماتك الشخصية، سنقوم إما بحذف هذه المعلومات أو تجريدها من هويتها، أو إذا لم يكن ذلك ممكنًا (على سبيل المثال، لأن معلوماتك الشخصية تم تخزينها في أرشيف النسخ الاحتياطي)، سنقوم بتخزين معلوماتك الشخصية بشكل آمن وعزلها عن أي معالجة مستقبلية حتى يصبح الحذف ممكنًا.</p>


//             {/* Section 6 */}
//             <h3>6. كيف نحافظ على سلامة معلوماتك؟</h3>
// <p>باختصار: نهدف إلى حماية معلوماتك الشخصية من خلال نظام من التدابير التنظيمية والتقنية للأمان.</p>
// <p>لقد قمنا بتنفيذ تدابير أمان تقنية وتنظيمية مناسبة ومعقولة مصممة لحماية أمان أي معلومات شخصية نقوم بمعالجتها. ومع ذلك، على الرغم من جهودنا وتدابيرنا لحماية معلوماتك، لا يمكن ضمان أن أي نقل إلكتروني عبر الإنترنت أو تقنية تخزين معلومات يمكن أن يكون مضمون بنسبة 100%، لذا لا يمكننا أن نعد أو نضمن أن القراصنة الإلكترونيين أو المجرمين السيبرانيين أو أطراف ثالثة غير مصرح لها ستكون غير قادرة على اختراق أماننا وجمع معلوماتك بشكل غير قانوني أو الوصول إليها أو سرقتها أو تعديلها. على الرغم من أننا سنبذل قصارى جهدنا لحماية معلوماتك الشخصية، إلا أن نقل المعلومات الشخصية إلى ومن خدماتنا يتم على مسؤوليتك الشخصية. يجب عليك الوصول إلى الخدمات فقط في بيئة آمنة.</p>

//             {/* Section 7 */}
//             <h3>7. ما هي حقوق خصوصيتك؟</h3>
// <p>باختصار: في بعض المناطق، مثل منطقة الاتحاد الاقتصادي الأوروبي (المملكة المتحدة)، سويسرا، وكندا، لديك حقوق تسمح لك بزيادة الوصول إلى معلوماتك الشخصية والتحكم فيها بشكل أفضل. يمكنك مراجعة، تغيير، أو إنهاء حسابك في أي وقت.</p>
// <p>في بعض المناطق (مثل منطقة الاتحاد الاقتصادي الأوروبي والمملكة المتحدة وسويسرا وكندا)، لديك حقوق معينة وفقًا لقوانين حماية البيانات ذات الصلة. يمكن أن تشمل هذه الحقوق (i) الحق في طلب الوصول والحصول على نسخة من معلوماتك الشخصية، (ii) الحق في طلب تصحيح أو مسح المعلومات؛ (iii) الحق في تقييد معالجة معلوماتك الشخصية؛ (iv) إذا كان ذلك مناسبًا، الحق في نقل البيانات؛ و (v) عدم تعريضك لاتخاذ القرارات الآلية. في بعض الحالات، قد تكون لديك أيضًا الحق في الاعتراض على معالجة معلوماتك الشخصية. يمكنك تقديم طلب من هذا القبيل عن طريق الاتصال بنا باستخدام تفاصيل الاتصال المقدمة في القسم "كيف يمكنك الاتصال بنا بشأن هذا الإشعار؟" أدناه.</p>
// <p>سحب موافقتك: إذا كنا نعتمد على موافقتك لمعالجة معلوماتك الشخصية، التي قد تكون موافقة صريحة و/أو ضمنية وفقًا للقانون المعمول به، فلديك الحق في سحب موافقتك في أي وقت. يمكنك سحب موافقتك في أي وقت عن طريق الاتصال بنا باستخدام تفاصيل الاتصال المقدمة في القسم "كيف يمكنك الاتصال بنا بشأن هذا الإشعار؟" أدناه. ومع ذلك، يرجى ملاحظة أن ذلك لن يؤثر على قانونية المعالجة قبل سحب الموافقة على النحو المعمول به ولن يؤثر على معالجة معلوماتك الشخصية التي تعتمد على أسباب معالجة قانونية أخرى سوى الموافقة، حينما يسمح القانون المعمول به.</p>


//             {/* Section 8 */}
//             <h3>8. ضوابط ميزات عدم التتبع (Do-Not-Track)</h3>
// <p>معظم متصفحات الويب وبعض أنظمة التشغيل المحمولة وتطبيقات الجوال تتضمن ميزة أو إعداد "عدم التتبع (Do-Not-Track)" يمكنك تفعيله لإشارة تفضيل خصوصيتك عدم جمع ومراقبة البيانات حول أنشطتك عبر الإنترنت. في هذه المرحلة، لم يتم الانتهاء من معيار تكنولوجي موحد للاعتراف بإشارات عدم التتبع وتنفيذها بعد. وعلى هذا النحو، نحن لا نستجيب حاليًا لإشارات متصفح عدم التتبع (DNT) أو أي آلية أخرى تقوم بنقل اختيارك بشكل تلقائي بعدم تتبعك عبر الإنترنت. إذا تم اعتماد معيار لتتبع الإنترنت يجب أن نتبعه في المستقبل، سنقوم بإعلامك بذلك في إصدار معدل من هذا الإشعار بشأن الخصوصية.</p>

//             {/* Section 9 */}
//             <h3>9. هل لدى سكان الولايات المتحدة الأمريكية حقوق خصوصية محددة؟</h3>
// <p>باختصار: إذا كنتم مقيمين في الولايات المتحدة الأمريكية، فلديكم حقوق خصوصية محددة بخصوص الوصول إلى معلوماتكم الشخصية.</p>
// <p>ما هي فئات المعلومات الشخصية التي نجمعها؟</p>
// <p>لقد قمنا بجمع الفئات التالية من المعلومات الشخصية خلال الاثني عشر (12) شهرًا الماضية:</p>


// Voici la traduction en arabe du tableau que vous avez fourni :

// html
// Copy code
// <table>
//     <tr>
//         <th>الفئة</th>
//         <th>أمثلة</th>
//         <th>تم الجمع</th>
//     </tr>
//     <tr>
//         <td>أ. معرفات</td>
//         <td>تفاصيل الاتصال، مثل الاسم الحقيقي، اللقب، العنوان البريدي، رقم الهاتف أو الجوال، معرف شخصي فريد، معرف عبر الإنترنت، عنوان بروتوكول الإنترنت، عنوان البريد الإلكتروني، واسم الحساب</td>
//         <td>لا</td>
//     </tr>
//     <tr>
//         <td>ب. سمات التصنيف المحمية بموجب القانون الولائي أو الاتحادي</td>
//         <td>الجنس وتاريخ الميلاد</td>
//         <td>لا</td>
//     </tr>
//                 {/* ... Autres catégories ... */}
//             </table>
//             <p>قد نقوم أيضًا بجمع معلومات شخصية أخرى خارج هذه الفئات في حال التفاعل معنا شخصياً، عبر الإنترنت، أو عبر الهاتف أو البريد في سياق:</p>
// <ul>
//     <li>استلام المساعدة من خلال قنوات دعم العملاء لدينا</li>
//     <li>المشاركة في استطلاعات العملاء أو المسابقات</li>
//     <li>تسهيل تقديم خدماتنا والرد على استفساراتك</li>
// </ul>
// <p>كيف نستخدم ونشارك معلوماتك الشخصية؟</p>
// <p>تعرف على كيفية استخدام معلوماتك الشخصية في القسم "كيف نعالج معلوماتك؟"</p>
// <p>هل سيتم مشاركة معلوماتك مع أي شخص آخر؟</p>
// <p>قد نكشف عن معلوماتك الشخصية لمقدمي الخدمات لدينا وفقًا لاتفاق مكتوب بيننا وبين كل مقدم خدمة. تعرف المزيد حول كيفية الكشف عن المعلومات الشخصية في القسم "متى ومع من نشارك معلوماتك الشخصية؟"</p>
// <p>قد نستخدم معلوماتك الشخصية لأغراض أعمالنا الخاصة، مثل إجراء أبحاث داخلية لتطوير التكنولوجيا والتجريب. وهذا لا يُعتبر "بيعًا" لمعلوماتك الشخصية.</p>
// <p>لم نكشف أو بيع أو شارك أي معلومات شخصية مع أطراف ثالثة لأغراض تجارية أو تجارية في الاثني عشر (12) شهرًا السابقة. لن نبيع أو نشارك معلومات شخصية مستقبلًا تعود إلى زوار الموقع والمستخدمين والمستهلكين الآخرين.</p>



//             {/* Section 10 */}
//             <h3>10. هل نقوم بتحديث هذا الإشعار؟</h3>
// <p>باختصار: نعم، سنقوم بتحديث هذا الإشعار حسب الاقتضاء للامتثال للقوانين ذات الصلة.</p>
// <p>قد نقوم بتحديث هذا الإشعار الخاص بالخصوصية من وقت لآخر. سيتم الإشارة إلى الإصدار المحدث بواسطة تاريخ "المراجعة" المحدث وسيكون الإصدار المحدث ساري المفعول بمجرد أن يكون متاحًا. إذا قمنا بإجراء تغييرات كبيرة على هذا الإشعار الخاص بالخصوصية، قد نخطرك إما عبر نشر إشعار بتلك التغييرات بشكل بارز أو عبر إرسال إشعار مباشر إليك. نشجعك على مراجعة هذا الإشعار بشكل متكرر لتكون على علم بكيفية حماية معلوماتك.</p>

// <h3>11. كيف يمكنكم الاتصال بنا بشأن هذا الإشعار؟</h3>
// <p>إذا كان لديكم أسئلة أو تعليقات حول هذا الإشعار، يمكنكم الاتصال بنا عبر البريد على العنوان: Yuzult</p>

// <h3>12. كيف يمكنكم مراجعة، تحديث، أو حذف البيانات التي نجمعها منكم؟</h3>
// <p>بناءً على القوانين السارية في بلدكم، قد تكون لديكم الحق في طلب الوصول إلى المعلومات الشخصية التي نجمعها منكم، وتغيير تلك المعلومات، أو حذفها. لطلب مراجعة أو تحديث أو حذف معلوماتكم الشخصية، يُرجى ملء طلب وصول لموضوع البيانات وإرساله.</p>
// </div>




    );
}

export default PrivacyPolicyPageAr;
